






















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { required, maxLength, numeric } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

import { config } from '@/config/config';
import { PublishedApp } from '../shared/models';
import { btApi } from './services/btApi';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import Toast from '@/shared/services/toast';
import { BTInstalledApp, InstallBTRequest } from './models';

@Component({
	mixins: [validationMixin],
	validations: {
		username: { required },
		password: {required},
		mobileVirtualNumber: {required, maxLength: maxLength(15), numeric}
	}
})
export default class BtSmsConfig extends Vue {
	@Getter public currentApp!: PublishedApp;
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public btApp: BTInstalledApp | null = null;
	public webhookUrl: string = `${config().btHost}/v1/webhook`;
	public username: string = '';
	public password: string = '';
	public mobileVirtualNumber: string = '';

	public actionInProgress: boolean = false;

	public created() {
		if (this.currentApp.isInstalled) {
			btApi.getInstalledApp(this.currentWorkspace.id)
				.then(btApp => {
					this.btApp = btApp;

					if (btApp) {
						this.username = btApp.username;
						this.password = btApp.password;
						this.mobileVirtualNumber = btApp.mobileVirtualNumber;
					}
				}).catch(err => {
					// if it's not found, then we haven't installed the bt app fully, so let them fill in the form
					if (err.status !== 404) {
						// show error state...
					}
				}).finally(() => {
					this.$emit('loaded');
				});
		} else {
			this.$emit('loaded');
		}
	}

	public onCopy() {
		Toast.showInfo('Copied to clipboard');
	}

	public save() {
		if (this.actionInProgress) {
			return;
		}

		this.actionInProgress = true;

		const request = {
			installId: this.currentApp.installedAppId,
			workspaceId: this.currentWorkspace.id,
			username: this.username,
			password: this.password,
			mobileVirtualNumber: this.mobileVirtualNumber
		} as InstallBTRequest;

		btApi.install(request)
			.then(() => this.$emit('configSaved'))
			.catch((err) => Toast.showError(err.message))
			.finally(() => this.actionInProgress = false);
	}

	public cancel() {
		this.$router.push({ name: 'apps' });
	}

}
